// cartQuantityManager.js

export class CartQuantityManager {
  constructor(options = {}) {
    // Optionally pass in selectors for plus/minus buttons or container class
    this.plusSelector = options.plusSelector || 'button[name="plus"]';
    this.minusSelector = options.minusSelector || 'button[name="minus"]';
    this.cartFormSelector = options.cartFormSelector || '#cart';

    this.init();
  }

  init() {
    // Cache DOM nodes
    const plusButtons = document.querySelectorAll(this.plusSelector);
    const minusButtons = document.querySelectorAll(this.minusSelector);

    // Bind plus
    plusButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.updateQuantity(button, 1);
      });
    });

    // Bind minus
    minusButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.updateQuantity(button, -1);
      });
    });
  }

  updateQuantity(button, delta) {
    try {
      // Find the closest cart item container
      let container = button.closest('.t-items-center');
      if (!container) {
        console.error('Item container not found');
        return;
      }

      // Get the item index from the button's data attribute
      const itemIndex = button.getAttribute('data-item-index');
      if (!itemIndex) {
        console.error('No item index found on button');
        return;
      }

      // Find the input using the item index
      const quantityInput = document.getElementById('Quantity-' + itemIndex);
      if (!quantityInput) {
        console.error('Quantity input not found for index:', itemIndex);
        return;
      }

      const currentQuantity = parseInt(quantityInput.value, 10);
      let newQuantity = currentQuantity + delta;

      if (newQuantity < 1) newQuantity = 1;

      // Update the quantity input value
      quantityInput.value = newQuantity;

      // Update the displayed quantity using the item index
      const quantityDisplay = document.getElementById('QuantityText-' + itemIndex);
      if (quantityDisplay) {
        quantityDisplay.textContent = newQuantity;
      } else {
        console.error('Quantity display element not found for index:', itemIndex);
      }

      // Submit the form to update the cart
      const form = document.querySelector(this.cartFormSelector);
      if (form) {
        form.submit();
      } else {
        console.error('Cart form not found');
      }
    } catch (error) {
      console.error('Error updating quantity:', error);
    }
  }
}
